import {lazy} from 'react';
import {Navigate, Route, Routes} from 'react-router-dom';
import SuspensedView from '../common/components/SuspendedView';
import {MasterLayout} from '../common/components/layout/MaterLayout';
import Dashboard from '../modules/dashboard/Dashboard';
import {routes} from './routes';
import Profile from '../modules/auth/pages/profile/Profile';
import VerifyProfile from '../modules/auth/pages/verify-profile/VerifyProfile';
import {useAuth, AuthLayout} from '../modules/auth';
import Notifications from '../modules/dashboard/pages/Notifications';
import Help from '../modules/help/Help';

const PrivateRoutes = () => {
	const CampaignRoutes = lazy(() => import('../modules/campaign/CampaignRoutes'));
	const AccountRoutes = lazy(() => import('../modules/account/AccountRoutes'));

	const {isProfileVerified, isProfileComplete} = useAuth();
	const incompleteRoute = isProfileVerified ? routes.completeProfile : routes.verifyProfile;
	const home = isProfileComplete ? routes.dashboard : incompleteRoute;

	return (
		<Routes>
			<Route path='auth/*' element={<Navigate to={home} />} />

			{isProfileComplete ? (
				<Route element={<MasterLayout />}>
					{/* Pages */}
					<Route path={routes.dashboard} element={<Dashboard />} />
					<Route path={routes.notifications} element={<Notifications />} />

					<Route
						path={routes.campaign.any}
						element={
							<SuspensedView>
								<CampaignRoutes />
							</SuspensedView>
						}
					/>

					<Route
						path={routes.accountSettingsRoutes.any}
						element={
							<SuspensedView>
								<AccountRoutes />
							</SuspensedView>
						}
					/>
					<Route path={routes.help} element={<Help />} />
				</Route>
			) : (
				<Route element={<AuthLayout />}>
					<Route path={routes.verifyProfile} element={<VerifyProfile />} />
					<Route path={routes.completeProfile} element={<Profile />} />
					<Route path='*' element={<Navigate to={home} />} />
				</Route>
			)}

			<Route path='*' element={<Navigate to='/error/404' />} />
		</Routes>
	);
};

export default PrivateRoutes;
